import { atom } from "jotai";
import type { CatalogResponse } from "@models/catalog";

export const catalogsAtom = atom<CatalogResponse[]>([]);

export const isFetchingCatalogsAtom = atom<boolean>(false);

export const isProcessingCatalogsAtom = atom<boolean>(false);
